// @flow
import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@material-ui/core';
import NutrientItem from './NutrientItem';
import * as ProgramTypes from '../../../state/reducer/calendar/programTypes';

export default function NutritionCard({ dayKey }: Props) {
    const nutrition = useSelector(
        (state: {}) => state.calendar.nutrition[dayKey]
    );

    const athleteProfileImage = useSelector((state: {}) => {
        if (
            !ProgramTypes.isCoachAthleteCalendar(
                state.calendar.infoTree.programType
            )
        ) {
            return;
        }

        const athlete = state.library.athletesTree.find(
            (athlete: any) => athlete.id === state.calendar.infoTree.athleteId
        );
        return athlete ? athlete.image_profile : null;
    });

    if (!nutrition) {
        return null;
    }

    const { calories, protein, carbohydrates, totalFat } = nutrition;

    return (
        <Box marginX={2} marginY={1} className="nutrition-card">
            <Box display="flex" flexDirection="row">
                {athleteProfileImage ? (
                    <img
                        alt="athlete-avatar"
                        src={athleteProfileImage}
                        style={{
                            height: 20,
                            width: 20,
                            borderRadius: '50%',
                            marginRight: 4
                        }}
                    />
                ) : null}
                <Typography
                    style={{
                        fontSize: 12,
                        fontWeight: 700
                    }}
                >
                    Daily Nutrition
                </Typography>
            </Box>
            <Box
                display="flex"
                direction="row"
                justifyContent="space-evenly"
                alignItems="center"
                marginTop={1}
                paddingX={0.5}
                style={{
                    borderRadius: 4,
                    flexWrap: 'wrap',
                    backgroundColor: '#F7F7F7'
                }}
            >
                <Box
                    display="flex"
                    direction="row"
                    justifyContent="space-evenly"
                    alignItems="center"
                    flex={1}
                >
                    <NutrientItem label="K&nbsp;Cal" value={calories} />
                    <NutrientItem label="Protein" value={protein} unit="g" />
                </Box>
                <Box
                    display="flex"
                    direction="row"
                    justifyContent="space-evenly"
                    alignItems="center"
                    flex={1}
                >
                    <NutrientItem
                        label="Carbs"
                        value={carbohydrates}
                        unit="g"
                    />
                    <NutrientItem label="Fat" value={totalFat} unit="g" />
                </Box>
            </Box>
        </Box>
    );
}



// WEBPACK FOOTER //
// ./src/view/calendar/components/NutritionCard.jsx